<template>
  <div>
    <v-row >
      <v-col cols="6" sm="3" md="2">
        <decimal-number-input dense label="Duty-free price" suffix="/case" v-model="dutyFreePrice" disabled hint="Calculated automatically" persistent-hint/>
      </v-col>
    </v-row>
   </div>
</template>

<script>

export default {
  name: 'BondedSelling',
  props: {
    product: {type:Object, required:true},
    taxes: {type:Array, required:true}
  },
  data() {
    return {
      valid: true,
      dutyFreePrice: 0
    }
  },
  watch: {
    item: {
      handler() {this.$emit('input', true);},
      immediate: true,
      deep: true
    },
    async 'product.defaultBondedPrice'() {
      this.getDutyFreePrice();
    },
    async 'product.provincialDetails.category'() {
      this.getDutyFreePrice();
    }
  },
  methods: {
    async getDutyFreePrice() {
      const results = await this.$apiCall(`query BondedSelling($input:OntarioDutyFreePriceInput!) {
                                              ontarioDutyFreePrice(input:$input)
                                            }`,
                                            {input:{lcboPrice:this.product.defaultBondedPrice, cooler:this.product.provincialDetails.category==='C'}});
      if (!results.error)
        this.dutyFreePrice = results.data.ontarioDutyFreePrice;
    }
  }
}
</script>